import { BlocksIconPlayCircleOutline } from 'blocks-nextjs/blocks-web-components/components/icon/icons/play-circle-outline';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconPlayCircleOutline = createComponent({
  react: React,
  tagName: 'cat-icon-play-circle-outline',
  elementClass: BlocksIconPlayCircleOutline
});
